import { memo } from "react";
import Clipboard from "ui/molecules/Clipboard";
import Label from "./Label";
import type { PaymentMethodTagProps } from "./types";

const PaymentMethodTag = ({ slotProps, tag }: PaymentMethodTagProps) => (
    <Label
        title='Tag'
        {...slotProps?.label}
    >
        <Clipboard
            sx={{
                fontWeight: 700,
            }}
        >
            {tag}
        </Clipboard>
    </Label>
);

export default memo(PaymentMethodTag);
